<template>
  <div>
    <v-data-table
      :items="filteredResults"
      :items-per-page="20"
      :headers="headers"
      class="elevation-1 pointer"
      @click:row="rowClick"
    >
      <template v-slot:[`item.file`]="{ item }">
        <div class="imageDiv">
          <med-package-image
            :imageFile="item.file"
            :maxWidth="100"
            :maxHeight="80"
            :defaultHeight="60"
          ></med-package-image>
        </div>
      </template>
      <template v-slot:[`item.brand_name`]="{ item }">
        <div class="subtitle-2">
          {{ item.brand_name }}
        </div>
        <i class="font-size-smaller">{{ item.generic_name | truncate(80) }}</i>
        <div class="caption">{{ item.manufacturer | truncate(50) }}</div>
      </template>
      <!-- <template v-slot:[`item.manufacturer`]="{ item }">
        {{ item.manufacturer | truncate(50) }}
      </template> -->
      <template v-slot:[`item.product_type`]="{ item }">
        <med-icons
          v-if="item.product_type"
          kind="rx"
          :val="item.product_type"
          :showLabel="false"
        ></med-icons>
      </template>
      <template v-slot:[`item.dosage_form`]="{ item }">
        <med-icons kind="form" :val="item.dosage_form"></med-icons>
      </template>
      <template v-slot:[`item.is_brand`]="{ item }">
        <med-icons
          v-if="item.is_brand && !item.product_type.includes('OTC')"
          kind="brand"
          :val="item.is_brand"
          :showLabel="false"
        ></med-icons>
      </template>
      <template v-slot:[`item.pf`]="{ item }">
        <v-icon v-if="item.pf == 1" color="green">mdi-check-bold</v-icon>
        <v-icon v-else color="red">mdi-minus</v-icon>
      </template>
      <template v-slot:[`item.price`]="{ item }">
        <med-icons
          v-if="item.is_brand && !item.product_type.includes('OTC')"
          kind="brand"
          :val="item.is_brand"
          :showLabel="item.price > 0"
          :labelOveride="'$' + item.price"
        ></med-icons>

        <div v-if="item.price > 0">
          ${{ item.price }}
          <span v-if="item.price_generic > 0"
            ><br />(${{ item.price_generic }})</span
          >
        </div>
      </template>
      <template v-slot:[`item.pediatric_days`]="{ item }">
        <div v-if="item.pediatric_unit == 'all'">Indicated</div>
        <div v-else-if="item.pediatric_unit == 'none'">Not indicated</div>
        <div v-else-if="item.pediatric_unit == 'mo'">
          {{ item.pediatric_age }} mo
        </div>
        <div v-else-if="item.pediatric_unit == 'yr'">
          {{ item.pediatric_age }} yr
        </div>
      </template>
      <template v-slot:[`item.categories`]="{ item }">
        <div
          v-for="(category, index) in uniqueArrForCategoryArr(item.categories)"
          :key="index"
        >
          <ul>
            <li>{{ category }}</li>
          </ul>
        </div>
      </template>
    </v-data-table>
    <v-card class="mt-4">
      <v-card-text class="caption" v-if="filteredResults.length > 0">
        <div class="my-2">
          <sup>*</sup> Pricing data is compiled from a number of sources and is
          intended to serve as a basis for comparison.
          <ul>
            <li>
              Prices can significantly vary between different pharmacies and
              retailers.
            </li>
            <li>
              Price comparisons between different products may not be comparing
              similar product sizes.
            </li>
            <li>
              Numbers in parentheses indicate price of generic equivalents.
            </li>
            <li>
              Filter products by price will hide products for which no pricing
              data is available.
            </li>
          </ul>
        </div>
        <div class="my-2">
          <sup>**</sup> Pediatric recommendations are based on FDA drug
          classifications and are intended help the prescriber narrow down
          potential prescribing options.
          <ul>
            <li>
              <b
                >Always click the medication listing and read the product's FDA
                listing before making prescribing decisions.
              </b>
            </li>
            <li>
              Filtering products by the pediatric field will hide products for
              which no pediatric data is available.
            </li>
          </ul>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// import Name from "../dir/file";
import MedPackageImage from "./MedPackageImage";
import MedIcons from "./MedIcons.vue";
import Slugify from "slugify";

export default {
  name: "MedsResultsTable",
  components: {
    MedPackageImage,
    MedIcons,
  },

  props: {
    filteredResults: null, // filtered in MedsResults.vue
    metadata: null,
    searchTitle: null,
  },
  data: function () {
    return {
      headerOptions: {
        rx: { text: "Rx", value: "product_type" },
        file: { text: "", value: "file" },
        name: {
          text: "Name",
          align: "start",
          value: "brand_name",
        },
        // manufacturer: { text: "Manufacturer", value: "manufacturer" },

        form: { text: "Form", value: "dosage_form" },
        price: { text: "Price*", value: "price" },
        pediatric: { text: "Pediatric**", value: "pediatric_days" },
        brand: { text: "Brand", value: "is_brand" },
        pf: { text: "Preservative Free", value: "pf" },

        category: { text: "MOA/Category", value: "categories" },
      },
    };
  },
  methods: {
    //   categoryForId(id) {
    //       if (!this.metadata?.categories?.byId) return null;
    //         return this.metadata.categories.byId[parseInt(id)];
    //   }
    slugText(name) {
      return Slugify(name.toLowerCase());
    },
    rowClick(row) {
      // console.log(row);
      let url = `/meds/details/${row.id}/`;
      url += this.slugText(row.brand_name);
      this.$router.push({ path: url });
      //this.$emit("rowSelected", { id: row.id, brand_name: row.brand_name });
    },

    // todo - this method is messy and hard-coded: find another way . . .
    uniqueArrForCategoryArr(arr) {
      if (!this.metadata?.categories?.byId) return null;
      let included = [];
      let rtn = [];
      let searchTitle = this.searchTitle.toLowerCase();
      for (const catId of arr) {
        let add = true;
        if (included.includes(catId)) add = false;
        let catName = this.categoriesById[catId].name;
        let lowerName = catName.toLowerCase();
        included.push(catId);
        if (lowerName == searchTitle) add = false;
        if (searchTitle == "combo" && lowerName == "antibiotic") add = false;
        if (searchTitle == "combo" && lowerName == "corticosteroid")
          add = false;

        if (add) rtn.push(catName);
      }
      return rtn;
    },
  },
  computed: {
    categoriesById: function () {
      if (!this.metadata?.categories?.byId) return null;
      return this.metadata.categories.byId;
    },
    headers: function () {
      let headers = [];
      let o = this.headerOptions;
      let m = this.metadata ? this.metadata : null;
      let counts = m?.counts;

      headers.push(o.file);
      headers.push(o.name);
      if (counts?.rx > 1) headers.push(o.rx);
      if (counts.rx > 1) headers.push(o.brand);
      // headers.push(o.manufacturer);
      headers.push(o.form);
      headers.push(o.price);
      headers.push(o.pediatric);

      if (counts.pf > 1) headers.push(o.pf);
      if (m?.categories?.byName.length > 1) headers.push(o.category);
      return headers;
    },
  },
};
</script>

<style scoped>
.imageDiv {
  min-width: 85px;
}
.pointer {
  cursor: pointer;
}
</style>
